// Create and save Christmas Gift Tag as a PDF
// The resizing of the text elements is handled by christmas.js (as we want this large file, ~500kb, to only be on the save page)

import html2canvas from 'Vendor/html2canvas';
import jsPDF       from 'Vendor/jspdf';

export default class GiftTag {
	constructor(){
		const element = document.getElementById('gift-tag');

		// We want to be sure that the text resizing has finished, so we check for .ready
		if(!element.classList.contains('ready')){
			return setTimeout(function() {
				this.pdf();
			}, 1000);
		}

		window.html2canvas = html2canvas;

		html2canvas(element).then(function(canvas) {
			const imgData  = canvas.toDataURL("image/jpeg", 1.0);

			if(window.location.search.includes("type=jpg")){
				const httpRequest = new XMLHttpRequest();
				httpRequest.onload = function() {
					const fileReader = new FileReader();
						fileReader.onloadend = function() {
							document.write('Right click the image below and select "save image" <br><img src="'+fileReader.result+'"></a>');
						}
					fileReader.readAsDataURL(httpRequest.response);
				};
				httpRequest.open('GET', imgData);
				httpRequest.responseType = 'blob';
				httpRequest.send();
			}
			else {
				const pdf      = new jsPDF('p', 'mm', 'a4'); // 210 x 297 mm
				const el       = document.getElementById('gift-tag');
				const width    = el.offsetWidth;
				const height   = el.offsetHeight;
				const pdfWidth = width / height * 100;
				const pdfHeight = height / width * 100;

				for(let i = 0; i < el.getAttribute('data-count'); i++) {
					pdf.addImage(imgData, 'JPEG', 10 + ((i % 3) * pdfWidth), 10 + (Math.floor(i / 3) * pdfHeight), pdfWidth, 100);
				}

				// The below gives a PDF preview, useful for testing

				// const iframe = document.createElement('iframe');
				// iframe.setAttribute('style', 'position:absolute;right:0; top:0; bottom:0; height:100%; width:500px');
				// document.body.appendChild(iframe);
				// iframe.src = pdf.output('datauristring');

				pdf.save("giveasyoulive-gift-tag.pdf");
				window.onfocus = function(){ window.close();}
			}
		});
	}
}

window.onload = function() {
	new GiftTag();
};